module.exports = __webpack_public_path__ + "static/media/crane7.6bfb9263.png";